<!-- =========================================================================================
  File Name: SessionAdd.vue
  Description: Session Add Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <form-wizard
    color="rgba(var(--vs-primary), 1)"
    :title="null"
    :subtitle="null"
    :startIndex="activeWizard"
    finishButtonText="Submit"
    @on-complete="formSubmitted"
    layout="vertical"   
    ref="forwizard" 
    v-if="session_data"
  >
    <tab-content
      title="Session Details"
      class="mb-5"
      :before-change="before_save"
      icon="feather icon-list"
    >
      <!-- Avatar Row -->
      <div class="vx-row">
        
        <div class="vx-col md:w-1/1 w-full">
          <!-- <h3>Session Type - {{session_data.SessionTypeDetails.TypeName}}</h3> -->
          <div class="custom-head-wrap">
              <!-- <h2 class="cms-custom-heading">Session Type - {{sessionType.label}}</h2>
              <p class="mt-1 mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p> -->
              <input
                type="text"
                name="Title"           
                v-model="session_data.Name"
                v-validate="'required'"
                class="w-full" id="" value="" placeholder="Session Title*"/>
                <span class="text-warning text-sm" v-show="session_data.Name.length > 20">For best view, 20 characters recommended ({{session_data.Name.length}}/20)</span>
                <span class="text-danger text-sm" v-show="errors.has('Title')">This field is required</span>
                <input
                type="text"
                v-model="session_data.DescriptionShort"
                class="w-full session-desc" id="" value="" placeholder="Session Description (Optional)"/>
                <span class="text-warning text-sm" v-show="session_data.DescriptionShort.length > 30">For best view, 30 characters recommended ({{session_data.DescriptionShort.length}}/30)</span>
          </div>
        </div>
        <!-- <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Title*</label>
          <vs-input
            class="inputx time-pkr"
            name="Title"
            placeholder="Title"
            v-model="session_data.Name"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('Title')">This field is required</span>
        </div> -->
        <!-- <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Short Description</label>
          <vs-input
            class="inputx time-pkr"
            placeholder="Short Description"
            v-model="session_data.DescriptionShort"
          />
        </div> -->
        <div class="vx-col md:w-6/12 mt-5 w-full">
          <div class="border-1">
            <div class="flex items-center flex-col sm:flex-row ">
              <div class="image-wrap-add-edit mt-2 mr-3">
                <img
                  :src="imgSrc"
                  class=""
                  style=""
                />
              </div>
              <!-- <vs-avatar :src="data_local.ProfilePictureURL" size="80px" class="mr-4" /> -->
              <div>
                <p class="text-lg font-medium mb-2 mt-4 sm:mt-0"></p>
                <input
                  id="uploadAvatar"
                  type="file"
                  class="hidden"
                  ref="update_avatar_input"
                  @change="update_avatar($event, 'SessionLogo', '200x100')"
                  accept="image/*"
                />

                <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                <vs-button
                  class="mr-4 edit-ssn-btn"
                  @click="$refs.update_avatar_input.click()"
                  >Upload</vs-button
                >                
                <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

                <!--<vs-button type="border" color="danger">Remove Avatar</vs-button>-->
              </div>
            </div>
            <p class="mt-2 edit-ssn-txt">Use a high quality image: 960 x 192px (5:1 ratio)</p>
          </div>
        </div>

        <div class="vx-col md:w-3/12 w-full mt-5">
          <label>Starts On<span class="essential">*</span></label>
          <flat-pickr
            :config="configdateTimePickerStart"
            name="Starts On"
            v-model="StartDate"
            v-validate="'required'"
            data-vv-validate-on="change"  
            placeholder="MM/DD/YYYY HH:MM"
            class="time-pkr"
            :disabled="session_data.StreamingClient.includes('Zoom')"
          />
          <span class="text-danger text-sm" v-show="errors.has('Starts On')">This field is required</span>
        </div>
        <div class="vx-col md:w-3/12 w-full mt-5">
          <label>Ends On<span class="essential">*</span></label>
          <flat-pickr
            :config="configdateTimePickerEnd"
            name="Ends On"
            v-model="EndDate"
            v-validate="'required'"
            data-vv-validate-on="change"  
            placeholder="MM/DD/YYYY HH:MM"
            class="time-pkr"
            :disabled="session_data.StreamingClient.includes('Zoom')"
          />
          <span class="text-danger text-sm" v-show="errors.has('Ends On')">This field is required</span>
        </div>
      </div>
      <!-- tab 1 content -->
      <div class="vx-row">
        
        
        <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Location</label>
          <vs-input
            class="inputx time-pkr"
            placeholder="Location"
            v-model="session_data.Location.LocationName"
          />
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Select Track</label>
          <div class="track-wrapper">
            <v-select
              class="track-select"
              label="TrackName"
              v-model="session_data.Track"
              :options="trackList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <vs-button color="primary" type="filled" @click="popupActive = true"
              >Add</vs-button
            >
            <div class="track-popup">
              <vs-popup
                class="holamundo"
                title="Add New Track"
                :active.sync="popupActive"
              >
                <div class="add-track-inner-section">
                  <vs-input
                    class="inputx input-track-name w-full"
                    placeholder="Track Name"
                    v-model="TrackName"
                  />
                  <!--<vs-input class="inputx input-track-name w-full" placeholder="ColorCode" v-model="ColorCode" />-->
                  <div class="color-choose">
                    <label>Select color code</label>
                    <input v-model="ColorCode" type="color" />
                  </div>
                  <vs-button  color="rgb(76, 139, 246)" type="filled" @click="addTrack">Add</vs-button>
                </div>
              </vs-popup>
            </div>
          </div>
        </div>
     
        <div class="vx-col md:w-1/2 w-full mt-5" v-if="!disablspeaker && session_data.TypeID != 6">
          <label v-if="session_data.TypeID == 3">Select Speakers<span class="essential">*</span></label>
          <label v-else>Select Speakers</label>
          <div class="track-wrapper" v-if="session_data.TypeID == 5">
            <v-select
              multiple
              :closeOnSelect="false"
              label="Name"
              v-model="session_data.MappedSpeakers"
              :options="speakerList"
              :OnChange="setHost()"
              v-on:input="limiter"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              name="Speaker"
              v-validate="mandatespeaker ? 'required' : ''"
              class="track-select"
            />            
            <vs-button color="primary" type="filled" @click="popupSpeakerAdd = true"
              >Add</vs-button>
          </div>
             <div class="track-wrapper" v-else>
            <v-select
              multiple
              :closeOnSelect="false"
              label="Name"
              v-model="session_data.MappedSpeakers"
              :options="speakerList"
              :OnChange="setHost()"
              v-on:input="limiter"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              name="Speaker"
              v-validate="mandatespeaker ? 'required' : ''"
              :disabled="disablspeaker"
              class="track-select"
            />            
            <vs-button color="primary" type="filled" @click="popupSpeakerAdd = true"
              >Add</vs-button>
          </div>
          <span class="text-danger text-sm" v-show="errors.has('Speaker')">{{
              errors.first("Speaker")
            }}</span>  
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5" v-if="!disablhost || session_data.TypeID == 5">
          <!-- <label>Select A Host</label> -->
          <label v-if="session_data.TypeID == 5">Select A Host</label>
          <label v-else>Select A Host<span class="essential">*</span></label>
          <v-select v-if="session_data.TypeID == 5"
            multiple
            :closeOnSelect="false"
            label="Name"
            v-model="session_data.MappedHosts"
            :options="attendessList"
            name="Host"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="{required:mandatehost, length:1}"
            :disabled="session_data.StreamingClient.includes('Zoom')"
          />
          <v-select v-else
            multiple
            :closeOnSelect="false"
            label="Name"
            v-model="session_data.MappedHosts"
            :options="attendessList"
            name="Host"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="{required:mandatehost, length:1}"
            :disabled="disablhost || session_data.StreamingClient.includes('Zoom')"
          />

          <span class="text-danger text-sm" v-show="errors.has('Host')">{{
            errors.first("Host")
          }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-5" v-if="(!disablhost && session_data.StreamingClient == 'Web') ||
            session_data.value == 5">
          <label>Select A Co-Host</label>
          <v-select            
            label="Name"
            v-model="session_data.MappedCoHost"
            :options="attendessList"
            name="CoHost"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            :disabled="session_data.StreamingClient.includes('Zoom')"
          />
        </div>
        
        <div class="vx-col md:w-6/12 w-full mt-5" v-if="session_data.TypeID==3">
          <label>Streaming Client</label>
          <div class="w-full">
            <ul class="streaming-client-wrap">
              <li :class="session_data.StreamingClient=='Web'? 'active' : ''">
                <vs-radio
                  v-model="session_data.StreamingClient"
                  vs-value="Web"
                  name="StreamingClient"
                  color="#ffffff"
                  :disabled="$route.params.sessionId"
                  >Web</vs-radio
                > 
              </li>
              <li :class="session_data.StreamingClient == 'Zoom' ? 'active' : ''">                
                <vs-radio
                  class="ml-3"
                  v-model="session_data.StreamingClient"
                  vs-value="Zoom"
                  color="#ffffff"
                  name="StreamingClient"
                  :disabled="$route.params.sessionId"
                  >Zoom Client</vs-radio
                >                  
              </li>
              <li
                :class="session_data.StreamingClient == 'ZoomWeb' ? 'active' : ''"
              >
                <vs-radio
                  class="ml-3"
                  v-model="session_data.StreamingClient"
                  vs-value="ZoomWeb"
                  name="StreamingClient"
                  color="#ffffff"
                  :disabled="$route.params.sessionId"
                  >Zoom Web</vs-radio
                >
              </li>
            </ul>            
          </div>
        </div>
        <div class="vx-col md:w-3/12 w-full mt-5" v-if="session_data.StreamingClient.includes('Zoom')">          
          <label>Enable RTMP Stream</label>
          <div class="w-full mt-4">
            <vs-switch
              v-model="session_data.IsZoomRTMP"
              :disabled="$route.params.sessionId"
            />
          </div>
        </div>
        <div class="vx-col md:w-3/12 w-full mt-5" v-if="![5,6].includes(session_data.TypeID) && session_data.StreamingClient == 'Web'">          
          <label>Enable RTMP Stream</label>
          <div class="w-full mt-4">
            <vs-switch
              v-model="session_data.IsRTMP"
              :disabled="$route.params.sessionId"
            />
          </div>
        </div>
           <div class="vx-col md:w-3/12 w-full mt-5" v-if="[3].includes(session_data.TypeID) && session_data.StreamingClient == 'Web' && session_data.SessionTypeDetails">          
          <label>Enable Breakout Room</label>


          <div class="w-full mt-4">
            <vs-switch
              v-model="session_data.SessionTypeDetails.EnableBreakoutRoom"
              :disabled="$route.params.sessionId"
            />
          </div>
        </div>
        <div class="vx-col md:w-3/12 w-full mt-5" v-if="session_data.StreamingClient.includes('Zoom') && !session_data.IsZoomRTMP">
          <label>Webinar Capacity</label>
          <v-select            
            v-model="session_data.WebinarCapacity"
            :options="[500,1000,3000]"
            name="WebinarCapacity"
            :disabled="$route.params.sessionId"
          />
        </div>   

        <div class="vx-col md:w-1/2 w-full mt-5">
          <label>Session Visible for</label>
          <v-select           
            v-model="session_data.SessionVisibleFor"
            :options="[
              { label: 'Everyone', value: 1 },
              { label: 'User Group', value: 2 },
              { label: 'List of Attendees', value: 3 },
            ]"
          />
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5" v-if="session_data.SessionVisibleFor.value == 2">
          <label>Select Groups</label>
          <v-select
            multiple
            v-model="SelectedGroups"
            :options="GroupList"
            label="GroupName"
            name="Groups"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('Groups')">This field is required</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-5" v-if="session_data.SessionVisibleFor.value == 3">
          <label>Select Attendees</label>
          <v-select
            multiple
            v-model="SelectedAttendees"
            :options="AttendeeList"
            label="Name"
            name="AttendeeList"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('AttendeeList')">This field is required</span>
        </div>   
        <div
          class="vx-col md:w-1/2 w-full mt-5"
          v-if="['EDU', 'UAT'].includes(Environment)"
        >
          <label>Select Batch</label>
          <v-select
            v-model="Batch"
            :options="SessionBatchList"
            label="BatchName"
          />
        </div>
      </div>
      <div class="vx-row px-3" v-show="PlanDetails.AllowSessionRoundtable" v-if="session_data.TypeID == 4">
        <div class="custom-head-wrap w-full">
              <h2 class="cms-custom-heading px-1">
                  Select a Roundtable Group to Map with this session
              </h2>
        </div>               
        
        <div class="map-round-table-wrapper session-details-sec mt-5" v-if="session_data.TypeID==4">
          
          <ul>
            <li
              v-for="rt in roundtableList"
              :class="
                session_data.RoundTables &&
                rt.TopicId == session_data.RoundTables.TopicId
                  ? 'active-round-table-group'
                  : ''
              "
            >
              <!--<vs-radio class="mr-5" v-model="session_data.RoundTables" vs-name="table" :value="rt" :checked="rt.TopicId == session_data.RoundTables.TopicId ? 'checked' : ''" ></vs-radio>-->
              <label>
                <input
                  class="mr-5"
                  name="RoundTableTopic"
                  type="radio"
                  v-model="session_data.RoundTables"
                  v-validate="session_data.MapExistingRoundTableGroup ? 'required' : ''"
                  v-bind:value="rt"
                  v-bind:checked="
                    session_data.RoundTables &&
                    rt.TopicId == session_data.RoundTables.TopicId
                  "
                />
                {{ rt.TopicDisplayName }}                    
              </label>
            </li>
          </ul>
          <span class="text-danger text-sm" v-show="errors.has('form-tab2.RoundTableTopic')">Please select group</span>
        </div>
      </div>
    </tab-content>

    <!-- tab 2 content -->
    <tab-content title="More Options" class="mb-5" icon="feather icon-check-circle" :before-change="before_save2">
      <form @submit.prevent="validateForm('form-tab2')" data-vv-scope="form-tab2">
      <div>
        <!--<h3>Select a Session Type</h3>-->
        <!--<vs-tabs color="rgb(32, 201, 192)">
              <vs-tab label="Select a Session Type">-->

        <!-- left -->
        <div class="custom-head-wrap mb-5">
                <h1 class="cms-custom-heading">
                    {{session_data.Name}}
                </h1>
                <p class="mt-1 mb-0">{{session_data.DescriptionShort}}</p>
            </div>
        <vs-tabs v-model="slectedTab" position="top" color="danger">
          <vs-tab class="px-0" v-if="session_data.TypeID == 3"  @click="session_data.TypeID = 3" label="">
            <div class="custom-head-wrap mb-5">
              <h2 class="cms-custom-heading">
                Settings
              </h2>
            </div>
            <div class="vx-row">
              <!--<div class="vx-col md:w-1/2 w-full">
                        <vs-checkbox v-model="session_data.LivePanel">Selected</vs-checkbox>
                      </div>-->
              <div class="vx-col md:w-1/2 w-full">
                <div class="single-option-select" v-if="session_data.StreamingClient=='Web' || session_data.IsZoomRTMP">
                  <label> Show Group Chat </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.EnableGroupChat">
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>

                <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web' || session_data.IsZoomRTMP">
                  <label> Show Attendee List </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.ShowAttendeeList">
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>

                <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web' || session_data.IsZoomRTMP">
                  <label> Show Speaker List </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.ShowSpeakerList">
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>

                <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web' || session_data.IsZoomRTMP">
                  <label> Audience Poll </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.AudiencePoll">
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>

                <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web' || session_data.IsZoomRTMP">
                  <label> Show Agenda </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.ShowAgenda">
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>

                <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web'">
                  <label> Enable Raise Hand </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.EnableRaiseHand">
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label> Enable Invite Session Attendee </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableInviteSessionAttendee">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
              <div class="mt-4 single-option-select" v-if="session_data.StreamingClient=='Web'">
                <label> Enable Spot Light </label>
                <div class="ml-4">
                  <vs-switch v-model="session_data.EnableSpotlight">
                    <span slot="true">True</span>
                    <span slot="false">False</span>
                  </vs-switch>
                </div>
              </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="single-option-select" v-if="session_data.StreamingClient=='Web' || session_data.IsZoomRTMP">
                  <label> Enable Live QnA (Auto publishes Questions) </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.EnableLiveQnA">
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select" v-if="session_data.StreamingClient=='Web' || session_data.IsZoomRTMP">
                  <label> >> Allow posting Questions Anonymously</label>
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.AllowPostingQuestionsAnonymously"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select" v-if="session_data.StreamingClient=='Web' || session_data.IsZoomRTMP">
                  <label>
                    >> Activate Moderation(2 step - Approval & Publish)</label
                  >
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.QnAModeration"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select" v-if="session_data.StreamingClient=='Web' || session_data.IsZoomRTMP">
                  <label>
                    >> Activate Moderation(1 step - Approve & Auto-Publish)
                  </label>
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.QnAAutoPublish"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 single-option-select">
                  <label>
                    Convert To OnDemand Video On Session End
                  </label>
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.ConvertToOnDemandVideoOnSessionEnd"
                    >
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div>
                <!-- <div class="mt-4 single-option-select" v-if="session_data.IsZoomRTMP">
                  <vs-button  color="rgb(76, 139, 246)" type="filled" class="sub-btn" v-on:click="enableRTMPMeeting">Start RTMP streaming for Audience view</vs-button>
                </div> -->
                <!-- <div class="mt-4 single-option-select">
                  <label> Enable Help / Settings </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.EnableHelpORSettings">
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                  </div>
                </div> -->
              </div>
            </div>
          </vs-tab>
          <vs-tab
            @click="session_data.TypeID = 1"
            v-show="PlanDetails.AllowSessionOnDemandVideo"
            label=""
            v-if="session_data.TypeID == 1"
            class="custom-session-ondemand px-0"
          >
            <div class="vx-row ">
              <div class="vx-col md:w-12/12 w-full">
                <div class="vx-row">
                  <div class="vx-col md:w-1/1 w-full">
                    <div class="custom-head-wrap mb-5">
                        <h2 class="cms-custom-heading">
                            Upload Video
                        </h2>
                    </div>
                    <div class="custom-inline-sec">
                      <vs-button class="mr-4" @click="open_video_window">
                        <span style="line-height: 0; margin-right: 10px"
                          ><feather-icon
                            class="sm:inline-flex cursor-pointer p-0 m-0 extrenal-ico"
                            icon="ExternalLinkIcon"
                        /></span>
                        <span>Launch Video Uploader</span></vs-button
                      >

                      <p>(Allowed File Types: .mp4, .mov, .avi, .wmv)</p>
                    </div>
                  </div>
                  <!--<div class="vx-col md:w-7/12 w-full mb-3 ">-->
                  <!-- <vs-upload single text="Browse or Upload Video" :show-upload-button="false" class="compose-mail-attachment" />                       
                              <input type="file" class="hidden" ref="upload_video_input" @change="upload_video" accept="video/*" />
                              <vs-button class="mr-4 mb-4" @click="$refs.upload_video_input.click()">Upload Video</vs-button> -->

                  <!--</div>-->
                </div>
                <div class="vx-row">
                  <div class="vx-col md:w-1/1 my-5 w-full read-box new-box">
                    
                    <div class="custom-inline-sec">
                      <div class="url-box-wrap">
                        <label>URL Will Auto Generate after Video Upload</label>
                        <vs-input
                          readonly
                          class="inputx time-pkr w-full"
                          placeholder=""
                          v-model="session_data.ODVideoURL"
                        />
                      </div>

                      <div class="streem-button">
                        <a
                          class="hover:text-primary cursor-pointer mt-9 manual-button"
                          @click="popupActive2 = true"
                          >Add Manually</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-row">
                  <!--<div class="vx-col md:w-6/12 my-3 ">
                              <label>Video Length (In Minutes)</label>
                              <vs-input class="inputx time-pkr" placeholder="" v-model="session_data.ODVideoLengthMinutes" />
                            </div>-->
                  <div class="vx-col md:w-12/12 w-full mt-5">
                      <div class="custom-head-wrap mb-5">
                        <h2 class="cms-custom-heading">
                          Settings
                        </h2>
                      </div>
                      <div class="other-settings-inner-wrap px-0">
                        <ul>
                          <li>
                            <div class="on-demand-single-option">
                              <label
                                ><span class="mr-2">Show Player Controls</span>
                                <vs-switch
                                  v-model="session_data.PlayerControl"
                                ></vs-switch
                              ></label>
                            </div>
                          </li>
                          <li>
                            <div class="on-demand-single-option">
                              <label
                                ><span class="mr-2">Enable Group Chat</span>
                                <vs-switch
                                  v-model="session_data.EnableGroupChat"
                                ></vs-switch
                              ></label>
                            </div>
                          </li>
                          <li>
                            <div class="on-demand-single-option">
                              <label
                                ><span class="mr-2">Show Attendee List</span>
                                <vs-switch
                                  v-model="session_data.ShowAttendeeList"
                                ></vs-switch
                              ></label>
                            </div>
                          </li>
                        </ul>
                      </div>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-12/12 w-full my-3 mt-8">
                <div class="bottombar-enable-section">
                  <label>Enable Bottom Bar</label>
                  <vs-switch
                    v-model="session_data.EnableBottomBar"
                    class="ml-5"
                  />
                </div>
                <div
                  class="mt-4 photo-album-selection"
                  v-show="session_data.EnableBottomBar"
                >
                  <label>Select Photo Album</label>
                  <div class="select-album">
                    <v-select
                      class="track-select"
                      name="photoDirectory"
                      label="photoDirectory"
                      v-model="session_data.PhotoWallAlbum"
                      :options="PhotoWallAlbumList"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                  </div>
                </div>
                <div
                  class="mt-4 embed-code-space"
                  v-show="session_data.EnableBottomBar"
                >
                  <label>Embed Code</label>
                  <vs-textarea v-model="session_data.EmbedCode" />
                </div>
                <div
                  class="mt-4 embed-code-space"
                  v-show="session_data.EnableBottomBar"
                >
                  <label>Display</label>
                  <ul class="centerx">
                    <li>
                      <vs-radio
                        @change="updateDisplay"
                        v-model="session_data.Active"
                        vs-value="PhotoWallAlbum"
                        >Photo Wall Album</vs-radio
                      >
                    </li>
                    <li>
                      <vs-radio
                        @change="updateDisplay"
                        v-model="session_data.Active"
                        vs-value="EmbedCode"
                        >Embed Code</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full my-3">
                <!--<video width="100%" height="300" controls>
                            <source :src="session_data.ODVideoURL" type="application/x-mpegURL"> 
                            </video>-->
              </div>
            </div>
          </vs-tab>
          <vs-tab
            @click="session_data.TypeID = 2"
            v-show="PlanDetails.AllowSessionLiveSimulated"
            label=""
            class="mt-0 px-0"
            v-if="session_data.TypeID == 2"
          >
            <div class="live-stream-inner-wrapper">
              <div class="vx-row">
                <div class="vx-col md:w-1/1 w-full">
                  <div class="custom-head-wrap mb-5">
                      <h2 class="cms-custom-heading">
                          Upload Video
                      </h2>
                  </div>
                  <h5 class="mb-3">
                    This Live-Stream Session will Play Between:<br />
                    <span style="font-weight: 300">{{
                      scheduleInUTCString
                    }}</span>
                  </h5>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col md:w-12/12 w-full my-3">
                  <!--<div class="vx-col md:w-1/2 my-3 ">
                          <label>Upload Video</label>
                          <vs-upload text="Browse or Upload Video" :show-upload-button="false" class="compose-mail-attachment mt-5" />
                        </div>
                        <div class="vx-col md:w-1/1 w-full my-3 ">
                            <video width="100%" height="300" controls>
                              <source src="https://www.youtube.com/watch?v=yAoLSRbwxL8" type="video/mp4">
                            </video>
                        </div>-->
                  <div class="vx-col md:w-1/1 w-full">
                    <!--<p class="mb-2">SCHEDULING FOR: <span>{{scheduleInUTCString}}</span></p>-->
                    <vs-radio
                      class=""
                      v-model="session_data.LSVideoURLType"
                      vs-value="LSVideoURL"
                      name="LSVideoURLType"
                      >Upload Video</vs-radio
                    >
                    <vs-radio
                      class="ml-3"
                      v-model="session_data.LSVideoURLType"
                      vs-value="RTMPURL"
                      name="LSVideoURLType"
                      >RTMP</vs-radio
                    >
                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-1/1 w-full mb-5">
                      <div class="custom-inline-sec">
                        <vs-button
                          class="mr-4"
                          @click="open_video_window"
                          v-show="session_data.LSVideoURLType == 'LSVideoURL'"
                        >
                          <span style="line-height: 0; margin-right: 10px"
                            ><feather-icon
                              class="sm:inline-flex cursor-pointer p-0 m-0 extrenal-ico"
                              icon="ExternalLinkIcon"
                          /></span>

                          <span>Launch Video Uploader</span>
                        </vs-button>
                        <p>(Allowed File Types: .mp4, .mov, .avi, .wmv)</p>
                      </div>
                    </div>
                    <!--<div class="vx-col md:w-7/12 w-full mb-3 ">-->
                    <!-- <vs-upload single text="Browse or Upload Video" :show-upload-button="false" class="compose-mail-attachment" />                       
                              <input type="file" class="hidden" ref="upload_video_input" @change="upload_video" accept="video/*" />
                              <vs-button class="mr-4 mb-4" @click="$refs.upload_video_input.click()">Upload Video</vs-button> -->

                    <!--</div>-->
                  </div>
                  <div
                    class="vx-col md:w-1/1 w-full my-3"
                    v-show="session_data.LSVideoURLType == 'RTMPURL'"
                  >
                    <label>RTMP URL<Span class="mand">*</Span></label>
                    <vs-input
                      class="inputx time-pkr"
                      placeholder=""
                      v-model="session_data.RTMPURL"
                    />
                  </div>
                  <div
                    class="vx-col md:w-1/1 w-full my-3"
                    v-show="session_data.LSVideoURLType == 'RTMPURL'"
                  >
                    <label>Stream Key</label>
                    <vs-input
                      class="inputx time-pkr"
                      placeholder=""
                      v-model="session_data.StreamKey"
                    />
                    <p class="mt-3 mb-0">
                      Learn more how to setup OBS, SLOBS, XSplit or your
                      favorite encoder. <a href="#">Setup guide</a>
                    </p>
                  </div>

                  <div class="vx-row">
                    <div
                      class="vx-col md:w-1/1 w-full read-box"
                      v-show="session_data.LSVideoURLType == 'LSVideoURL'"
                    >
                      <div class="custom-inline-sec session-type-wrap">
                        <div class="url-box-wrap  w-full">
                          <div class="stream-url-wrap live-stram-panel">
                            <label
                              >Live Stream URL Will Auto Generate after Video
                              Upload</label
                            >
                            <vs-input
                              readonly
                              class="inputx time-pkr w-full"
                              placeholder=""
                              v-model="session_data.LSVideoURL"
                            />
                          </div>

                            <div
                            class="streem-button details-stream"
                            v-show="session_data.LSVideoURLType == 'LSVideoURL'"
                          >
                            <a
                              class="hover:text-primary cursor-pointer manual-button"
                              @click="checkScheduling"
                              >Stream Schedule Status</a
                            >
                            </div>
                        </div>
                        <div
                          class="streem-button add-manu"
                          v-show="session_data.LSVideoURLType == 'LSVideoURL'"
                        >
                          <a
                            class="hover:text-primary cursor-pointer ml-5 manual-button"
                            @click="popupActive2 = true"
                            >Add Manually</a
                          >
                        </div>
                      </div>
                    </div>
                    <div class="vx-col md:w-4/12"></div>
                  </div>
                  <div
                    class="vx-col md:w-1/2 w-full my-3"
                    v-show="session_data.LSVideoURLType == 'LSVideoURL'"
                  >
                  </div>
                  <div class="vx-col md:w-12/12 w-full mt-5 mb-5">
                    <div class="vx-row">
                      <div class="vx-col md:w-1/1 w-full mb-4">
                       <div class="custom-head-wrap mb-5">
                          <h2 class="cms-custom-heading">
                            Settings
                          </h2>
                        </div>
                      </div>
                      <div class="other-settings-inner-wrap">
                        <ul>
                          <li>
                            <div class="on-demand-single-option">
                              <label
                                ><span class="mr-2">Show Player Controls</span>
                                <vs-switch
                                  v-model="session_data.PlayerControl"
                                ></vs-switch
                              ></label>
                            </div>
                          </li>
                          <li>
                            <div class="on-demand-single-option">
                              <label
                                ><span class="mr-2">Enable Group Chat</span>
                                <vs-switch
                                  v-model="session_data.EnableGroupChat"
                                ></vs-switch
                              ></label>
                            </div>
                          </li>
                          <li>
                            <div class="on-demand-single-option">
                              <label
                                ><span class="mr-2">Show Attendee List</span>
                                <vs-switch
                                  v-model="session_data.ShowAttendeeList"
                                ></vs-switch
                              ></label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <!--<div class="vx-col md:w-1/1 w-full">
                          <vs-button class="mr-4 mb-4" @click="open_video_window">Save</vs-button> 
                        </div>-->
                </div>
                <div class="vx-col md:w-12/12 w-full my-3">
                  <div class="bottombar-enable-section">
                    <label>Enable Bottom Bar</label>
                    <vs-switch
                      v-model="session_data.EnableBottomBar"
                      class="ml-5"
                    />
                  </div>
                  <div
                    class="mt-4 photo-album-selection"
                    v-show="session_data.EnableBottomBar"
                  >
                    <label>Select Photo Album</label>
                    <div class="select-album">
                      <v-select
                        class="track-select"
                        name="photoDirectory"
                        label="photoDirectory"
                        v-model="session_data.PhotoWallAlbum"
                        :options="PhotoWallAlbumList"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      />
                    </div>
                  </div>
                  <div
                    class="mt-4 embed-code-space"
                    v-show="session_data.EnableBottomBar"
                  >
                    <label>Embed Code</label>
                    <vs-textarea v-model="session_data.EmbedCode" />
                  </div>
                  <div
                    class="mt-4 embed-code-space"
                    v-show="session_data.EnableBottomBar"
                  >
                    <label>Display</label>
                    <ul class="centerx">
                      <li>
                        <vs-radio
                          @change="updateDisplay"
                          v-model="session_data.Active"
                          vs-value="PhotoWallAlbum"
                          >Photo Wall Album</vs-radio
                        >
                      </li>
                      <li>
                        <vs-radio
                          @change="updateDisplay"
                          v-model="session_data.Active"
                          vs-value="EmbedCode"
                          >Embed Code</vs-radio
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!--
                      <div class="vx-row">
                        <div class="vx-col md:w-1/2 my-3 ">
                          <label>Pre-Roll Image(16:9) </label>                          
                          <vs-upload action="" @on-success="successUpload" />
                        </div>
                        <div class="vx-col md:w-1/2 my-3 ">
                          <label>Post-Roll Image(16:9)</label>                          
                          <vs-upload action="" @on-success="successUpload" />
                        </div>
                      </div>
                      -->
            </div>
          </vs-tab>

          <vs-tab @click="session_data.TypeID = 5" label="" v-if="session_data.TypeID == 5" class="px-0">            
            <!-- <vs-checkbox v-model="session_data.Imperson">Enable</vs-checkbox> -->
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="single-option-select">
                  <label> Show Group Chat </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.EnableGroupChat">
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 single-option-select">
                  <label> Audience Poll </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.AudiencePoll">
                    </vs-switch>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="single-option-select">
                  <label> Enable Live QnA (Auto publishes Questions) </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.EnableLiveQnA">
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select">
                  <label> >> Allow posting Questions Anonymously</label>
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.AllowPostingQuestionsAnonymously"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select">
                  <label>
                    >> Activate Moderation(2 step - Approval & Publish)</label
                  >
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.QnAModeration"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select">
                  <label>
                    >> Activate Moderation(1 step - Approve & Auto-Publish)
                  </label>
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.QnAAutoPublish"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                    </vs-switch>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/1 w-full mt-5">
                <label>Upload Custom Icon</label>
                <img
                  :src="session_data.InPersonIcon"
                  class="mr-8 ml-8 rounded w-25 h-25"                  
                />
                <vs-input
                  class="inputx time-pkr"
                  name="InPersonIcon"
                  placeholder="Upload Custom Icon"
                  v-model="session_data.InPersonIcon"
                />
                <input
                  type="file"
                  @change="uploadRandomImage"
                  accept="image/*"
                />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <label>Icon Text</label>
                <vs-input
                  class="inputx time-pkr"
                  name="InPersonLabel"
                  placeholder="Icon Text"
                  v-model="session_data.InPersonLabel"
                />
              </div>              
              <!-- <div class="vx-col md:w-1/2 w-full mt-5">
                <label>Hyperlink (opens in new tab)</label>
                <vs-input
                  class="inputx time-pkr"
                  name="InPersonLabel"
                  placeholder="Hyperlink (opens in new tab)"
                  v-model="session_data.InPersonURL"
                />
              </div> -->
              <div class="vx-col md:w-1/2 w-full mt-5">
                <label>Attendee URL (opens in new tab)</label>
                <vs-input
                  class="inputx time-pkr"
                  placeholder="Attendee URL (opens in new tab)"
                  v-model="session_data.AttendeeURL"
                />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <label>Speaker URL (opens in new tab)</label>
                <vs-input
                  class="inputx time-pkr"
                  placeholder="Speaker URL (opens in new tab)"
                  v-model="session_data.SpeakerURL"
                />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <label>Host URL (opens in new tab)</label>
                <vs-input
                  class="inputx time-pkr"
                  placeholder="Host URL (opens in new tab)"
                  v-model="session_data.HostURL"
                />
              </div>
              
            </div>
          </vs-tab>
          <vs-tab @click="session_data.TypeID = 5" label="" v-if="session_data.TypeID == 6" class="px-0">            
            <!-- <vs-checkbox v-model="session_data.Imperson">Enable</vs-checkbox> -->
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="single-option-select">
                  <label> Show Group Chat </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.EnableGroupChat">
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 single-option-select">
                  <label> Audience Poll </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.AudiencePoll">
                    </vs-switch>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="single-option-select">
                  <label> Enable Live QnA (Auto publishes Questions) </label>
                  <div class="ml-4">
                    <vs-switch v-model="session_data.EnableLiveQnA">
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select">
                  <label> >> Allow posting Questions Anonymously</label>
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.AllowPostingQuestionsAnonymously"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select">
                  <label>
                    >> Activate Moderation(2 step - Approval & Publish)</label
                  >
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.QnAModeration"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                    </vs-switch>
                  </div>
                </div>
                <div class="mt-4 pl-5 single-option-select">
                  <label>
                    >> Activate Moderation(1 step - Approve & Auto-Publish)
                  </label>
                  <div class="ml-4">
                    <vs-switch
                      v-model="session_data.QnAAutoPublish"
                      :disabled="!session_data.EnableLiveQnA"
                    >
                    </vs-switch>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/1 w-full mt-5">
                <label>Upload Custom Icon</label>
                <img
                  :src="session_data.InPersonIcon"
                  class="mr-8 ml-8 rounded w-25 h-25"                  
                />
                <vs-input
                  class="inputx time-pkr"
                  name="InPersonIcon"
                  placeholder="Upload Custom Icon"
                  v-model="session_data.InPersonIcon"
                />
                <input
                  type="file"
                  @change="uploadRandomImage"
                  accept="image/*"
                />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <label>Icon Text</label>
                <vs-input
                  class="inputx time-pkr"
                  name="InPersonLabel"
                  placeholder="Icon Text"
                  v-model="session_data.InPersonLabel"
                />
              </div>              
              
              
            </div>
          </vs-tab>
        </vs-tabs>
            <div id="notification_section" class="custom-head-wrap mb-5" v-if="(session_data.StreamingClient=='Web' || session_data.IsZoomRTMP) && ![5,6].includes(session_data.TypeID)">
              <h2 class="cms-custom-heading">
                  Session Notification
              </h2>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full border-right-1" v-if="(session_data.StreamingClient=='Web'  || session_data.IsZoomRTMP) && ![5,6].includes(session_data.TypeID)">
              <h3>Before Start</h3>
              <div class="vx-col md:w-12/12 w-full mt-5 flex align-center">
                <div class="notification-msg">
                  <label>Send Notification before Session Start</label>
                  <vs-switch
                    class="ml-5" v-model="session_data.ShowSessionStartNotificationMessage"
                  />
                </div>
              </div>
              <div class="vx-col md:w-12/12 w-full mt-5 flex align-center">
                <div class="display-before">
                  <label>Display Before Session Start (Min)</label>
                  <vs-input-number
                    class="inputx time-pkr ml-8"
                    v-model="session_data.DisplayBeforeSessionStartMin"
                    name="StartMin"
                    min="1"
                    step="10"
                    v-validate="'required|min_value:1'"
                  />
                </div>
              </div>
              <div class="vx-col md:w-12/12 w-full mt-5 flex align-center">
                <div class="display-before">
                  <label>Display Before Session Start (Min)</label>
                  <vs-input-number
                    class="inputx time-pkr ml-8"
                    v-model="session_data.DisplayBeforeSessionStartMin_Secondary"
                    name="StartMin2"
                    min="1"
                    step="10"
                    v-validate="'required|min_value:1'"
                  />
                </div>
              </div>              
              <div class="vx-col md:w-1/1 w-full mt-5">
                <div class="notification-top-label">
                  <label>Notification Message</label>
                  <div class="streem-button flex items-center justify-end">
                    <a
                      class="hover:text-primary cursor-pointer manual-button mr-3"
                      @click="getMailTpl(true)"
                      >Template</a>
                      |
                    <a
                      class="hover:text-primary cursor-pointer manual-button ml-3"
                      @click="
                        session_data.StartNotificationMessage = Environment == 'EDU' ? DefaultStartNotificationMessageEDU : DefaultStartNotificationMessage
                      "
                      >Reset</a
                    >
                  </div>
                </div>

                <vs-input
                  class="inputx time-pkr"
                  placeholder="Short Description"
                  v-model="session_data.StartNotificationMessage"
                />
              </div>
              <div class="vx-col md:w-12/12 w-full mt-5 flex align-center">
                <label>Notification Send To</label>
                <vs-radio
                    class="ml-3"
                    v-model="session_data.StartNotificationSendTo"
                    vs-value="Email"
                    name="EmailAndSMS"
                    >Email</vs-radio
                  > 
                <vs-radio
                    class="ml-3"
                    v-model="session_data.StartNotificationSendTo"
                    vs-value="EmailAndSMS"
                    name="EmailAndSMS"
                    >Email & SMS</vs-radio
                  >
              </div>
              <div class="mt-5 border-1">
                <div class="vx-col md:w-12/12 w-full flex align-center">
                  <div class="display-before">
                    <label>Display Before Session Start <b>(Hour)</b></label>
                    <vs-input-number
                      class="inputx time-pkr ml-8"
                      v-model="session_data.DisplayBeforeSessionStart_Hour"
                      name="StartHour"
                      min="1"
                      step="1"
                      v-validate="'required|min_value:1'"
                    />
                  </div>
                </div>
                <div class="vx-col md:w-12/12 w-full mt-3 flex align-center">
                  <label>Notification Send <b>(Hour)</b></label>
                  <vs-radio
                      class="ml-3"
                      v-model="session_data.StartNotificationSendToThird"
                      vs-value="EmailOnly"
                      name="EmailAndSMSThird"
                      >Email</vs-radio
                    > 
                  <vs-radio
                      class="ml-3"
                      v-model="session_data.StartNotificationSendToThird"
                      vs-value="EmailAndSMSBoth"
                      name="EmailAndSMSThird"
                      >Email & SMS</vs-radio
                    >
                </div>
              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full" v-if="(session_data.StreamingClient=='Web' || session_data.IsZoomRTMP) && ![5,6].includes(session_data.TypeID)">
              <h3>Before End</h3>
              <div class="vx-col md:w-12/12 w-full mt-5 flex align-center">
                <div class="notification-msg">
                  <label>Show Session End Notification Message</label>
                  <vs-switch
                    class="ml-5" v-model="session_data.ShowSessionEndNotificationMessage"
                  />
                </div>
              </div>
          

              <div class="vx-col md:w-12/12 w-full mt-5 flex align-center">
                <div class="display-before">
                  <label>Display Before Session End (Sec)</label>
                  <!--<flat-pickr :config="configdateTimePickerTime" name="DisplayBeforeSessionEndSecs" v-model="DisplayBeforeSessionEndSecs" class="time-pkr"/>-->
                  <vs-input-number
                    class="inputx time-pkr ml-8"
                    v-model="session_data.DisplayBeforeSessionEndSecs"
                    name="Time"
                    min="1"
                    step="10"
                    v-validate="'required|min_value:1'"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('Time')">{{
                    errors.first("Time")
                  }}</span>
                </div>
              </div>

              <div class="vx-col md:w-1/1 w-full mt-5">
                <div class="notification-top-label">
                  <label>Notification Message</label>
                  <div class="streem-button">
                    <a
                      class="hover:text-primary cursor-pointer manual-button"
                      @click="
                        session_data.NotificationMessage = DefaultNotificationMessage
                      "
                      >Reset</a
                    >
                  </div>
                </div>

                <vs-input
                  class="inputx time-pkr"
                  placeholder="Short Description"
                  v-model="session_data.NotificationMessage"
                />
              </div>
            </div>
          </div>
        
        <div class="vx-col md:w-1-12 w-full mt-5">
          <div class="custom-head-wrap mb-5">
              <h2 class="cms-custom-heading">
                  Description
              </h2>
            </div>
          <!-- <quill-editor v-model="session_data.Description"> </quill-editor> -->
          <ckeditor class="desc-event" v-model="session_data.Description" :config="editorConfig"></ckeditor>
          <span class="text-warning text-sm" v-show="session_data.Description.length > 60">For best view, 60 characters recommended ({{session_data.Description.length}}/60)</span>
        </div>
        <div class="vx-col md:w-1-12 w-full" v-if="session_data.TypeID==5">
          <vs-collapse type="margin">
            <vs-collapse-item>
              <div slot="header">
                Optional Settings
              </div>
              <div class="vx-row mb-5">
                <div class="vx-col md:w-1/3 w-full mt-5" v-if="session_data.TypeID==5">
                  <label>Hide Time</label>
                  <vs-switch v-model="session_data.HideTime"/>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5" v-if="session_data.TypeID==5">
                  <label>Hide Join Button</label>
                  <vs-switch v-model="session_data.HideJoinButton"/>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5" v-if="session_data.TypeID==5">
                  <label>Hide Track</label>
                  <vs-switch v-model="session_data.HideTrack"/>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5" v-if="session_data.TypeID==5">
                  <label>Hide Title</label>
                  <vs-switch v-model="session_data.HideTitle"/>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5" v-if="session_data.TypeID==5">
                  <label>Hide Short Description</label>
                  <vs-switch v-model="session_data.HideShortDescription"/>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5" v-if="session_data.TypeID==5">
                  <label>Hide Speakers</label>
                  <vs-switch v-model="session_data.HideSpeakers"/>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5" v-if="session_data.TypeID==5">
                  <label>Show In Separate Row</label>
                  <vs-switch v-model="session_data.ShowInSeparateRow"/>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5" v-if="session_data.TypeID==5 && session_data.ShowInSeparateRow">
                  <label>Show Before Concurrent Sessions</label>
                  <vs-switch v-model="session_data.ShowBeforeConcurrentSessions"/>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5" v-if="session_data.TypeID==5">
                  <label>Show Feature Image</label>
                  <vs-switch v-model="session_data.ShowFeatureImage"/>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5" v-if="session_data.TypeID==5 && session_data.ShowFeatureImage">
                  <label>Upload Feature Image</label>
                  <div class="flex flex-wrap items-center justify-start">
                    <img class="" v-if="session_data.FeatureImage" :src="session_data.FeatureImage" style="width:70px;height:35px;">
                    <vs-button class="ml-1 mr-5" v-if="session_data.FeatureImage" radius  color="danger" size="small" type="border" icon="delete" @click="session_data.FeatureImage = null;"></vs-button>
                    <vs-input class="inputx" type="file" accept="image/*" @change="update_avatar($event, 'FeatureImage', '200x100')"/>
                  </div>
                </div>
              </div>
            </vs-collapse-item>
          </vs-collapse>
        </div>
      </div>
    </form>
    </tab-content>

    <!-- tab 3 content -->
    <tab-content title="Resources" class="mb-5" icon="feather icon-file">
      <div class="custom-head-wrap mb-5">
          <h1 class="cms-custom-heading">
                    {{session_data.Name}}
                </h1>
                <p class="mt-1 mb-0">{{session_data.DescriptionShort}}</p>
      </div>
      <div class="custom-head-wrap mb-5">
          <h2 class="cms-custom-heading">
              Upload Resources
          </h2>
          <p class="mt-1 mb-0">Supported File types: .csv, .excel,.xlsx,.pdf,.doc,.docx </p>
      </div>
      <!-- <vs-upload multiple text="Upload Multiple Files" action="https://jsonplaceholder.typicode.com/posts/" @on-success="successUpload" accept=".pdf,.doc,.docx,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />-->
      <!--<div class="vx-col md:w-1/1 w-full mt-2">
            <label>Resources </label>
            <div class="vx-col md:w-1/1 w-full mt-2" v-for="file in session_data.Resources">
            <a :href="file">File</a>
            </div>

           <input type="file" multiple class="hidden" ref="update_resource_input" @change="upload_resources" accept=".csv.excel,.xlsx,.pdf,.doc,.docx">
                <vs-button class="mr-4 mb-4" @click="$refs.update_resource_input.click()">Upload Resources</vs-button>
          </div>-->
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mt-2">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 my-6">
              <div class="upload-area-wrap session-edit-upload-area-wrap">
                <input
                  type="file"
                  multiple
                  class="hidden"
                  ref="update_resource_input"
                  @change="upload_resources"
                />
                <vs-button
                  class="mr-4 mb-4"
                  @click="$refs.update_resource_input.click()"
                  >Upload Resources</vs-button
                >
              </div>
            </div>
            <div class="vx-col md:w-1/2 mb-3">
            <label>Uploaded Resources (Drag and drop to reorder)</label>
              <div class="resourse-file-list-wrap session-edit-resource-file">
                <draggable
                  :list="session_data.Resources"
                  :group="{ name: 'tags' }"
                  class="p-2 cursor-move menu-dragbox"
                >
                <div v-if="session_data.Resources.length"> 
                  <div
                    class="single-file-wrap"
                    v-for="file in session_data.Resources"
                  >
                    <div class="file-sec-wrap">
                      <a :href="file.name ? '#' : file">{{
                        file.name ? file.name : getFileName(file)
                      }}</a>
                      <a href="#"
                        ><img
                          @click="deleteFile(file)"
                          src="../../assets/images/delete.svg"
                      /></a>
                    </div>
                  </div>
                </div>
                <div v-else>No Resources uploaded yet!</div>
                </draggable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab-content>

    <template slot="footer" scope="props">
     <div class=wizard-footer-left>
         <vs-button  v-if="props.activeTabIndex == 0" @click.native="$router.push('/event/sessions')">Back to List</vs-button>
         <vs-button @click.native="props.prevTab()" v-else>Previous</vs-button>
      </div>
      <div class="wizard-footer-right">
        <vs-button v-if="props.activeTabIndex == 0"@click.native="props.nextTab()" class="wizard-footer-right ml-4" color="success">Save &amp; Continue</vs-button>
        <vs-button v-if="props.activeTabIndex == 1" @click.native="formSubmitted(true)" class="wizard-footer-right ml-4" color="success">Save &amp; Continue</vs-button>     
        <vs-button v-if="props.activeTabIndex == 1" @click.native="formSubmitted(false)" class="wizard-footer-right ml-4" color="success">Save &amp; Exit</vs-button>                 
        <vs-button v-if="props.isLastStep" @click.native="formSubmitted(false)" class="wizard-footer-right finish-button" color="success">Save &amp; Exit</vs-button>
      </div>       
    </template>

    <vs-popup class="holamundo" title="Edit Url" :active.sync="popupActive2">
      <div class="add-track-inner-section">
        <vs-input
          class="inputx time-pkr"
          placeholder="URL (.M3U8 Format Supported)"
          v-model="editUrlText"
        />
        <vs-button  color="rgb(76, 139, 246)" type="filled" @click="editUrl">Save</vs-button>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Scheduling Status"
      :active.sync="popupActive3"
    >
      <div v-html="schedulingMessage"></div>
    </vs-popup>
    <vs-popup class="holamundo addspeaker-popup" title="Add New Speaker" :active.sync="popupSpeakerAdd">
      <form @submit.prevent="validateForm('form-speaker')" data-vv-scope="form-speaker">
        <div class="row">
          <div class="vx-col w-full">
            <vs-input class="inputx input-track-name w-full" placeholder="First Name" v-model="SpeakerObj.FirstName" name="FirstName" v-validate="'required'"/>
            <span class="text-danger text-sm" v-show="errors.has('form-speaker.FirstName')">The First Name field is required</span>
          </div>
          <div class="vx-col w-full mt-5">
            <vs-input class="inputx input-track-name w-full" placeholder="Last Name" v-model="SpeakerObj.LastName" name="LastName" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('form-speaker.LastName')">The Last Name field is required</span>
          </div>
          <div class="vx-col w-full mt-5">
            <vs-input class="inputx input-track-name w-full" placeholder="Email" v-model="SpeakerObj.Email" name="Email" v-validate="'required|email'" />
            <span class="text-danger text-sm" v-show="errors.has('form-speaker.Email')">{{errors.first("form-speaker.Email")}}</span>
          </div>
          <div class="vx-col w-full mt-5">
            <vs-button  color="rgb(76, 139, 246)" type="filled" @click="addSpeaker">Add</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>
    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      fullscreen="fullscreen"
      v-if="cropImageUrl"
    >
      <h5>
        Aspect Ratio for this image is {{displayImageRatio}}. To crop
        this image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
    <vs-popup
          mailpopup
          class="holamundo customnewpopup"
          title="Notification Mail Template"
          :active.sync="popupActiveMail"
        >
      <vs-tabs>
        <vs-tab label="Preview">
          <div class="tab-text">
            <div class="vx-row" style="width: 622px">
              <div class="vx-col md:w-1/1 w-full mt-4">
                <h3>Subject: {{ welcomeMailSubject }}</h3>
              </div>
              <br />
              <div v-html="welcomeMailText"></div>
              <!--<quill-editor v-model="welcomeMailText"></quill-editor>-->
              <br />
              <div class="vx-col md:w-1/1 w-full mt-4">
                <div click="sendbtn-section">
                  <vs-button color="warning" type="border" @click="cancelMail"
                    >Cancel</vs-button
                  >
                  <!-- <vs-button
                    class="mail-btn ml-4"
                    color="success" type="filled"
                    @click="sendMail"
                    >Send Mail</vs-button
                  > -->
                </div>
              </div>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Edit">
          <div class="tab-text">
            <div class="vx-row" style="width: 622px">
              <div class="vx-col md:w-1/1 w-full mt-4">
                Subject:
                <vs-input
                  class="inputx w-full mt-4"
                  v-model="welcomeMailSubject"
                  v-validate="'required'"
                  name="Subject"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Subject')"
                  >{{ errors.first("Subject") }}</span
                >
                <br />Body:
                <vs-textarea
                  class="inputx w-full mt-4"
                  v-model="sourcehtml"
                  rows="10"
                  cols="100"
                />
                <br />
                <div click="sendbtn-section">
                  <vs-button color="warning" type="border" @click="cancelMail"
                    >Cancel</vs-button
                  >
                  <vs-button
                    class="mail-btn ml-4"
                    color="success" type="filled"
                    @click="saveMail"
                    >Save</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
  </form-wizard>
</template>



<script>
import con from "@/firebase/firebaseInit.ts";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment-timezone";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import XLSX from "xlsx";
import draggable from "vuedraggable";
import CKEditor from 'ckeditor4-vue';
import CKconfig from "@/assets/ckeditor-config.ts";
// Store Module
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleSpeakerManagement from "@/store/speaker-management/moduleSpeakerManagement.js";
import moduleTrackManagement from "@/store/track-management/moduleTrackManagement.js";
import moduleRoundTableManagement from "@/store/roundtable-management/moduleRoundtableManagement.js";
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import modulePhotoWall from "@/store/photowall-management/modulePhotowallManagement.js";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
import ls from "@/common/localStorage";

var cn = ls.getSessionEventCollectionName();
let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
let Session_EventStartDate = ls.getSessionValueByKey("Session_EventStartDate");
let Session_EventEndDate = ls.getSessionValueByKey("Session_EventEndDate");
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var oNewWindow = null;
var vm;
export default {
  name: "SessionEdit",
  components: {
    FormWizard,
    TabContent,
    flatPickr,
    "v-select": vSelect,
    quillEditor,
    draggable,
    ckeditor: CKEditor.component,
    PhotowallResizeComponent
  },

  data() {
    return {
      Environment: con.Environment,
      editorConfig: CKconfig.editorConfig,
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fon-air-white.png?alt=media", // "https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT_C1591904892446E1591907102804%2FSession%2FSettings%2F1600099550726_2048x2732.jpg?alt=media&token=82631343-f46a-4c56-b5ef-d518a63c363c",
      attendessList: [],
      ResourceFiles: [],
      speakerList: [],
      trackList: [],
      roundtableList: [],
      popupActiveMail: false,
      welcomeMailText: null,
      welcomeMailSubject: null,
      sourcehtml: null,
      session_data: null,
      SessionTypeDetails: null,
      session_not_found: false,
      scheduleInUTCString: null,
      DefaultNotificationMessage:
        "This session is about to end in {{countdown}}",
      //DefaultStartNotificationMessage: "{{SessionName}} is about to start in {{CountDownTime}} mins",
      DefaultStartNotificationMessage: "Dear {{FirstName}} this is a gentle reminder that {{SessionName}} of {{EventName}} will begin in {{CountDownTime}}. Date: {{StartDate}} to {{EndDate}}.",
      DefaultStartNotificationMessageEDU: "Dear {{FirstName}} You have an upcoming class for {{EventName}} {{SessionName}} Date: {{StartDate}} - {{EndTime}}. Please login {{CountDownTime}} before your session.",
      Environment: con.Environment,
      DisplayBeforeSessionEndSecs: null,
      StartDate: null,
      EndDate: null,
      LSDateTime: null,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      configdateTimePickerStart: {
        //minDate: new Date(),
        onChange: function (val) {
          if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      configdateTimePickerEnd: {
        minDate: null,
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      configdateTimePickerTime: {
        enableTime: true,
        enableSeconds: true,
        dateFormat: "i:s",
        defaultHour: 0,
        noCalendar: true,
        time_24hr: true,
      },
      editorOption: {
        theme: "bubble",
      },
      TrackName: null,
      ColorCode: null,
      color: null,
      popupActive: false,
      popupActive2: false,
      popupActive3: false,
      popupSpeakerAdd: false,
      schedulingMessage: null,
      tabIndex: 0,
      activeTabVal: 0,
      PlanDetails: {
        MaxAttendeesPerClient: 10,
        EnhancedEventBranding: false,
        AllowSessionOnDemandVideo: false,
        AllowSessionLiveSimulated: false,
        AllowSessionRoundtable: false,
        ShowBrandingEventSetup: false,
        MaxEventDays: 2,
        EventAccessPostEvent: false,
        EnhancedRegistration: false,
        ContractStartDate: new Date(),
        ContractEndDate: new Date(),
        PricePerExtraAttendee: 100,
      },
      EventData: null,
      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeWizard: 0,
      activeTab: 0,
      slectedTab: 0,
      editUrlText: null,
      PhotoWallAlbumList: [],
      disablhost: false,
      disablspeaker: false,
      mandatehost: false,
      mandatespeaker: false,
      SpeakerObj: {
        Company: null,
        CreatedDate: new Date(),
        Designation: null,
        Email: null,
        IsAttendee: true,
        IsSpeaker: true,
        FirstName: null,
        Group: null,
        LastModifiedDate: new Date(),
        LastName: null,
        Phone: null,
        Profile: null,
        IsPublished: true,
        Website: null
      },
      Batch: null,
      SessionBatchList: [],
      GroupList: [],
      SelectedGroups: [],
      AttendeeList: [],
      SelectedAttendees: [],
      Session_LocationType: ls.getSessionValueByKey("Session_LocationType"),
      imageRatio: 5 / 1,
      cropImageUrl: null,
      popupCropper: false,
      resetCropper: 0,
      displayImageRatio: '5 / 1',
      uploadedFile: null,
      uploadedFilefieldName: null
    };
  },
  watch: {
    activeTab() {
      this.fetch_session_data(this.$route.params.sessionId);
    },
    "session_data.TypeID"(value) {
      //console.log(value)
      //this.errors.clear()
      if ([1,2,5,6].includes(value)) {
        this.disablhost = true;
        this.disablspeaker = false;
        this.mandatehost = false;
        this.mandatespeaker = false;
      } else if (value == 3) {
        this.disablhost = false;
        this.disablspeaker = false;
        this.mandatehost = true;
        this.mandatespeaker = true;
      } else if (value == 4) {
        this.disablhost = true;
        this.disablspeaker = true;
        this.mandatehost = false;
        this.mandatespeaker = false;
      }
    },
    "session_data.EnableLiveQnA"(val) {
      this.session_data.QnAModeration = this.session_data.EnableLiveQnA
        ? this.session_data.QnAModeration
        : false;
      this.session_data.QnAAutoPublish = this.session_data.EnableLiveQnA
        ? this.session_data.QnAAutoPublish
        : false;
      this.session_data.AllowPostingQuestionsAnonymously = this.session_data.EnableLiveQnA
        ? this.session_data.AllowPostingQuestionsAnonymously
        : false;
    },
    "session_data.QnAModeration"(val) {
      this.session_data.QnAAutoPublish = val
        ? false
        : this.session_data.QnAAutoPublish;
    },
    "session_data.QnAAutoPublish"(val) {
      this.session_data.QnAModeration = val
        ? false
        : this.session_data.QnAModeration;
    },
    StartDate(val) {
      this.scheduleInUTCString =
        moment(this.StartDate).format("DD MMM YYYY, HH:mm") +
        " till " +
        moment(this.EndDate).format("DD MMM YYYY, HH:mm");
    },
    EndDate(val) {
      this.scheduleInUTCString =
        moment(this.StartDate).format("DD MMM YYYY, HH:mm") +
        " till " +
        moment(this.EndDate).format("DD MMM YYYY, HH:mm");
    },
  },
  methods: {
    cancelMail() {
      this.popupActiveMail = false;
    },
    getMailTpl(showPopup = false) {
      this.$vs.loading();
      this.welcomeMailText = "Loading...";
      this.$store
        .dispatch("sessionManagement/getMailTemplate")
        .then((res) => {
          this.welcomeMailText = res.html;
          this.welcomeMailSubject = res.subject;
          this.sourcehtml = res.sourcehtml;
          this.$vs.loading.close();
          if(showPopup)
            this.popupActiveMail = true;
        });
    },
    saveMail() {
      this.$vs.loading();
      this.$store
        .dispatch("sessionManagement/saveMail", {
          sourcehtml: this.sourcehtml,
          subject: this.welcomeMailSubject
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            title: "Mail Save",
            text: res.message,
          });
          this.$vs.loading.close();
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    enableRTMPMeeting(){
      this.$vs.loading();
      this.$store.dispatch("sessionManagement/enableZoomRTMPmeeting", this.session_data)
        .then((res) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: res.code == 1 ? "success" : "warning",
            position: "top-center",
            text: res.code == 1 ? "RTMP Enabled." : "Meeting not started!",
          });
        })
        .catch((err) => {
          console.error(err);
          this.$vs.loading.close();
        });
    },
    croppedImagePath(blob) {
      //this.imgSrc = blob;
      this.popupCropper = false;
      if(this.uploadedFile && this.uploadedFilefieldName)
        vm.uploadImage(blob, `${cn}/Session/LogoImage/`, this.uploadedFile, this.uploadedFilefieldName)
    },
    update_avatar(input, fieldName, fileWH) {
      debugger;
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        this.uploadedFile = file;
        this.uploadedFilefieldName = fieldName;
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileWH.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
            const reader = new FileReader();
            reader.onload = (e) => {
              //vm.imgSrc = e.target.result;
              vm.resetCropper += 1;
              vm.cropImageUrl = null;
              vm.cropImageUrl = e.target.result;
              vm.popupCropper = true;
            };
            reader.readAsDataURL(input.target.files[0]);
          
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadImage(fileBlob, target, file, fieldName){
      this.$vs.loading();
      this.$store.dispatch("sessionManagement/uploadFiles", [{blob:fileBlob, target:target, name:file.name,type:file.type}]).then((res) => {
        this.$vs.loading.close();
        if(res.data.length && res.data[0].status == "fulfilled")
        {
          if(fieldName == 'SessionLogo'){
            this.session_data.SessionLogo = res.data[0].value.url;
            this.imgSrc = res.data[0].value.url;
          }else if(fieldName == 'FeatureImage'){
            this.session_data.FeatureImage = res.data[0].value.url;
          }
        }
        else
        {
          this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "File not uploaded!",
            });
        }
      }).catch(err=>{ 
        this.$vs.loading.close(); 
        this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "Something went wrong!",
            });
      })
    },
    limiter(e) {
      let attcnt = 12;
      if (e.length > attcnt) {
        e.pop();
        this.$vs.notify({
          color: "warning",
          position: "top-center",
          //title: "Round Table",
          text: "You can only select " + attcnt + " users!",
        });
      }
    },
    before_save() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          resolve(result);
        });
      });
    },
    before_save2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('form-tab2').then((result) => {
          resolve(result);
        });
      });
    },
    deleteFile(file) {
      let name = "";
      if (file.name) {
        name = file.name;
      } else {
        name = file;
        const Id = this.$route.params.sessionId;
        if (Id) {
          this.$vs.loading();
          this.$store
            .dispatch("sessionManagement/deleteResource", {
              id: Id,
              name: name,
            })
            .then((res) => {
              this.$vs.loading.close();
            })
            .catch((err) => {
              console.error(err);
            });
        }
      }
      let index = this.session_data.Resources.indexOf(name);
      this.session_data.Resources.splice(index, 1);
      let index2 = this.ResourceFiles.indexOf(name);
      this.ResourceFiles.splice(index2, 1);
    },
    getFileName(downloadUrl) {
      let url = decodeURIComponent(downloadUrl);
      let arr = url.split("?");
      let arr2 = arr[0].split("/");
      let name = arr2[arr2.length - 1];
      return name;
    },
    fetch_session_data(sessionId) {
      //console.log(sessionId)
      this.$vs.loading();
      this.$store
        .dispatch("sessionManagement/fetchSession", sessionId)
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.SessionLogo) {
            this.imgSrc = res.data.SessionLogo;
          }
          this.Batch = res.data.Batch ? res.data.Batch : null;
          this.session_data = res.data;
          this.SelectedGroups = res.data.Groups ? res.data.Groups : [];
          this.SelectedAttendees = res.data.IncludedAttendees ? res.data.IncludedAttendees : [];
          //this.DisplayBeforeSessionEndSecs = res.data.DisplayBeforeSessionEndSecs ? this.getTimeFromSecond(res.data.DisplayBeforeSessionEndSecs) : null
          //this.slectedTab = this.session_data.TypeID - 1
          this.StartDate = res.data.StartDate
            ? this.SetTimeByZone(res.data.StartDate, Session_Event_TZ)
            : null;
          this.EndDate = res.data.EndDate
            ? this.SetTimeByZone(res.data.EndDate, Session_Event_TZ)
            : null;
          this.LSDateTime = res.data.LSDateTime
            ? this.SetTimeByZone(res.data.LSDateTime, Session_Event_TZ)
            : null;

          this.scheduleInUTCString =
            moment(this.StartDate).format("DD MMM YYYY, HH:mm") +
            " till " +
            moment(this.EndDate).format("DD MMM YYYY, HH:mm");

          if (
            new Date(this.StartDate).getTime() >=
              new Date(Session_EventStartDate).getTime() &&
            new Date(this.StartDate).getTime() <=
              new Date(Session_EventEndDate).getTime()
          ) {
            this.configdateTimePickerStart.minDate = new Date(
              Session_EventStartDate
            );
            this.configdateTimePickerStart.maxDate = new Date(
              Session_EventEndDate
            );
            if (
              new Date(this.StartDate).getTime() >=
                new Date(Session_EventStartDate).getTime() &&
              new Date(this.StartDate).getTime() <=
                new Date(Session_EventEndDate).getTime()
            ) {
              this.configdateTimePickerEnd.minDate = new Date(this.StartDate);
              this.configdateTimePickerEnd.maxDate = new Date(
                Session_EventEndDate
              );
            } else {
              this.configdateTimePickerEnd.minDate = new Date(
                Session_EventStartDate
              );
              this.configdateTimePickerEnd.maxDate = new Date(
                Session_EventEndDate
              );
            }
          } else {
            this.configdateTimePickerStart.minDate = new Date(this.StartDate);
            this.configdateTimePickerStart.maxDate = new Date(this.StartDate);
            this.configdateTimePickerEnd.minDate = new Date(this.EndDate);
            this.configdateTimePickerEnd.maxDate = new Date(this.EndDate);
          }

          //this.activeTab = 2
          
          if (res.data.SessionTypeDetails.TypeID == 1) {            
            this.slectedTab = 1;
          } else if (res.data.SessionTypeDetails.TypeID == 2) {            
            this.slectedTab = 2;
          } else if (res.data.SessionTypeDetails.TypeID == 3) {            
            this.slectedTab = 0;
          } else if (res.data.SessionTypeDetails.TypeID == 4) {            
            this.slectedTab = 3;
          } else if (res.data.SessionTypeDetails.TypeID == 5) {            
            this.slectedTab = 4;
          } else if (res.data.SessionTypeDetails.TypeID == 6) {            
            this.slectedTab = 5;
          }
          //console.log(this.session_data.RoundTables)
        })
        .catch((err) => {
          this.$vs.loading.close();
          /*if (err.response.status === 404) {
            this.session_not_found = true;
            return;
          }*/
          console.error(err);
        });
    },
    fetchClientPlanDetails() {
      this.$store
        .dispatch("clientManagement/fetchClientPlanDetails", Session_Client_Id)
        .then((res) => {
          if (res.PlanDetails) {
            this.PlanDetails = res.PlanDetails;
          }
        });
    },
    getAttendees(){
       this.$store.dispatch('attendeeManagement/fetchAttendees')
        .then(res => { 
          this.AttendeeList = res.map(row=>{
            return {
              AttendeeId: row.AttendeeId,
              Email: row.Email,
              FirstName: row.FirstName,
              LastName: row.LastName,
              Name: row.Name
            }
          });                    
        });
    },
    setHost() {
      this.attendessList = this.session_data.MappedSpeakers;
      //console.log('hello' + this.speakerList)
    },
    getSpeakers() {
      this.$store.dispatch("speakerManagement/fetchSpeakers").then((res) => {
        this.speakerList = [];
        for (let i = 0; i < res.length; i++) {
          this.speakerList.push({
            AttendeeId: res[i].SpeakerId,
            Company: res[i].Company,
            Designation: res[i].Designation,
            Email: res[i].Email,
            FirstName: res[i].FirstName,
            LastName: res[i].LastName,
            Name: res[i].Name,
            Phone: res[i].Phone,
            ProfilePictureURL: res[i].ProfilePictureURL
              ? res[i].ProfilePictureURL
              : "",
          });
        }
      });
    },
    getTracks() {
      this.$store
        .dispatch("trackManagement/fetchTracksDropdown")
        .then((res) => {
          this.trackList = res;
        });
    },
    getRoundTables() {
      this.$store
        .dispatch("roundtableManagement/fetchRoundTableTopicDropdown")
        .then((res) => {
          this.roundtableList = res;
          /*this.roundtableList = res.map((row) => {
            return {
              TopicId: row.TopicId,
              TopicName: row.TopicName,
              TopicTableCapacity: row.TopicTableCapacity,
            };
          });*/
        });
    },
    upload_video(input) {
      if (input.target.files.length) {
        for (var i = 0; i < input.target.files.length; i++) {
          const file = input.target.files[i];
          const metadata = {
            contentType: file.type,
          };
          //console.log(file)
          let filename = file.name;
          filename = filename.split(".").pop();
          //console.log(filename)
          const validImageTypes = ["mp4", "mov", "avi", "wmv"];
          if (!validImageTypes.includes(filename)) {
            alert("Only files allowed.");
            return false;
          }
          /*let FileSize = file.size / 1024 / 1024;
          if(FileSize > 200)
          {
            alert("Uploaded file size exceeds 20 MB");
            return false;
          }*/

          this.$vs.loading();
          let sessionId = this.$route.params.sessionId;
          this.$store
            .dispatch("sessionManagement/uploadVideo", {
              file: file,
              filename: file.name,
              contentType: file.type,
              sessionId: sessionId,
            })
            .then((res) => {
              this.session_data.ODVideoLengthMinutes = 5;
              this.session_data.ODVideoURL = res.url;
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Video",
                text: "Video Uploaded Successfully.",
              });
              this.$vs.loading.close();
            });
        }
      }
    },
    open_video_window() {
      let SessionId = this.$route.params.sessionId;
      let TypeID = this.session_data.TypeID;
      //let md = moment(this.StartDate, 'MM/DD/YYYY HH:mm').tz(Session_Event_TZ)
      let md = this.GetTimeByZone(this.StartDate, Session_Event_TZ);
      let scheduleInUTC = {
        year: md.getUTCFullYear(),
        month: md.getUTCMonth() + 1,
        day: md.getUTCDate(),
        hour: md.getUTCHours(),
        minute: md.getUTCMinutes(),
      };
      /*let scheduleInUTC = {
          "year": parseInt(md.format('YYYY')),
          "month": parseInt(md.format('MM')),
          "day": parseInt(md.format('DD')),
          "hour": parseInt(md.format('HH')),
          "minute": parseInt(md.format('mm')),
      }*/
      let info = {
        Session_scheduleInUTC: JSON.stringify(scheduleInUTC),
        Session_StartDate_UTC: md,
      };
      ls.setSessionUserInfo(info);
      oNewWindow = window.open(
        "/event/session/video/" + SessionId + "/" + TypeID,
        "_blank",
        "width=400,height=400,left=10,titlebar=0"
      );
    },
    uploadRandomImage(input) {
          let file = input.target.files[0];
          //console.log(file)
          let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
          if (!validImageTypes.includes(file.type)) {
            alert("Only gif,jpeg & png file allowed.");
            return false;
          }         
          this.$vs.loading();
          
          this.$store
            .dispatch("sessionManagement/uploadRandomImage", file)
            .then((res) => {
              if(res.ImageSrc){
                this.session_data.InPersonIcon = res.ImageSrc
              }
              this.$vs.notify({
                color: res.status == 200 ? "success" : "warning",
                position: "top-center",
                //title: "Video",
                text: res.message
              });
              this.$vs.loading.close();
            }).catch(err=>{
              this.$vs.loading.close();
            });
    },
    async upload_resources(input) {
      if (input.target.files.length) {
        let fileArr = [];        
        for (var i = 0; i < input.target.files.length; i++) {
          const file = input.target.files[i];
          const metadata = {
            contentType: file.type,
          };
          //console.log(file)
          let filename = file.name;
          filename = filename.split(".").pop();
          //console.log(filename)
          /*const validImageTypes = ['csv', 'pdf', 'xlsx', 'excel', 'doc', 'docx']
          if (!validImageTypes.includes(filename)) {
            alert('Only files allowed.')
            return false
          }*/
          let FileSize = file.size / 1024 / 1024;
          if (FileSize > 20) {
            alert("Uploaded file size exceeds 20 MB");
            return false;
          }
          

          await this.readFile(file).then(blob=>{
            let uploadObj = {blob:blob, target:`${cn}/Session/Resources/`, name:file.name,type:file.type};
            fileArr.push(uploadObj);
          })
          
          //this.session_data.Resources.push(file);
          //this.ResourceFiles.push(file);
        }
        this.uploadFile(fileArr);
      }
    },
    readFile(file){
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file); 
        reader.onload = (e) => {
          resolve(e.target.result);   
        };
      })
    },
     uploadFile(fileArr){
      this.$vs.loading();
      this.$store.dispatch("sessionManagement/uploadFiles", fileArr).then((res) => {
        console.log(res)
        this.$vs.loading.close();
        if(res.data.length)
        {
          res.data.map(fileData=>{
            if(fileData.status == "fulfilled")
            {
              this.session_data.Resources.push(fileData.value.url);
              this.ResourceFiles.push(fileData.value.name);
            }
          })
          
        }        
      }).catch(err=>{ 
        this.$vs.loading.close(); 
        this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "Something went wrong!",
            });
      })
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MM/DD/YYYY HH:mm");
      return date;
    },
    getTimeFromSecond: function (given_seconds) {
      let dateObj = new Date(given_seconds * 1000);
      let hours = dateObj.getUTCHours();
      let minutes = dateObj.getUTCMinutes();
      let seconds = dateObj.getSeconds();

      let timeString =
        hours.toString().padStart(2, "0") +
        ":" +
        minutes.toString().padStart(2, "0") +
        ":" +
        seconds.toString().padStart(2, "0");
      return timeString;
    },
    fetch_event_data() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$store
        .dispatch("eventManagement/fetchEvent", Session_Event_Id)
        .then((res) => {
          this.EventData = res.data;
          /*this.StartDate = this.StartDate ? this.SetTimeByZone(this.StartDate, res.data.TimeZone) : ''
          this.EndDate = this.EndDate ? this.SetTimeByZone(this.EndDate, res.data.TimeZone) : ''
          this.LSDateTime = this.LSDateTime ? this.SetTimeByZone(this.LSDateTime, res.data.TimeZone) : '' */
        });
    },
    updateDisplay() {
      this.$vs.loading();
      let ID = this.$route.params.sessionId;
      this.session_data.StartDate = this.GetTimeByZone(
        this.StartDate,
        this.EventData.TimeZone
      );
      this.session_data.EndDate = this.GetTimeByZone(
        this.EndDate,
        this.EventData.TimeZone
      );
      //let md = moment(this.StartDate, 'MM/DD/YYYY HH:mm')
      /*let md = moment(this.StartDate, 'MM/DD/YYYY HH:mm').tz(Session_Event_TZ).utc();
      let scheduleInUTC = {
          "year": parseInt(md.format('YYYY')),
          "month": parseInt(md.format('MM')),
          "day": parseInt(md.format('DD')),
          "hour": parseInt(md.format('HH')),
          "minute": parseInt(md.format('mm'))
      }*/
      let md = this.GetTimeByZone(this.StartDate, Session_Event_TZ);
      let scheduleInUTC = {
        year: md.getUTCFullYear(),
        month: md.getUTCMonth() + 1,
        day: md.getUTCDate(),
        hour: md.getUTCHours(),
        minute: md.getUTCMinutes(),
      };
      if (this.LSDateTime) {
        this.session_data.LSDateTime = this.GetTimeByZone(
          this.LSDateTime,
          this.EventData.TimeZone
        );
      }
      this.session_data.ResourceFiles = this.ResourceFiles;
      this.ResourceFiles = [];
      this.$store
        .dispatch("sessionManagement/updateBottomBarActiveDisplay", {
          id: ID,
          data: this.session_data,
          scheduleInUTC: scheduleInUTC,
        })
        .then(() => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            //title: "Session",
            text: "Display Updated.",
          });
          this.$vs.loading.close();
        });
    },
    formSubmitted(form_continue = false) {
      this.$vs.loading();
      let ID = this.$route.params.sessionId;
      /*this.session_data.StartDate = this.StartDate;
      this.session_data.EndDate = this.EndDate;
      this.session_data.LSDateTime = this.LSDateTime;*/
      
      this.session_data.StartDate = this.GetTimeByZone(
        this.StartDate,
        Session_Event_TZ
      );
      this.session_data.EndDate = this.GetTimeByZone(
        this.EndDate,
        Session_Event_TZ
      );
      //this.session_data.SessionLogo = vm.imgSrc;
      //let md = moment(this.StartDate, 'MM/DD/YYYY HH:mm')
      /*let md = moment(this.StartDate, 'MM/DD/YYYY HH:mm').tz(Session_Event_TZ).utc();
      let scheduleInUTC = {
          "year": parseInt(md.format('YYYY')),
          "month": parseInt(md.format('MM')),
          "day": parseInt(md.format('DD')),
          "hour": parseInt(md.format('HH')),
          "minute": parseInt(md.format('mm'))
      }*/
      let md = this.GetTimeByZone(this.StartDate, Session_Event_TZ);
      let scheduleInUTC = {
        year: md.getUTCFullYear(),
        month: md.getUTCMonth() + 1,
        day: md.getUTCDate(),
        hour: md.getUTCHours(),
        minute: md.getUTCMinutes(),
      };
      /*this.session_data.DisplayBeforeSessionEndSecs = null
      if(this.DisplayBeforeSessionEndSecs)
      {
        let a = this.DisplayBeforeSessionEndSecs.split(':');
        this.session_data.DisplayBeforeSessionEndSecs = (+a[0]) * 60 * 60 + (+a[1]) * 60;
      }*/
      if (this.LSDateTime) {
        this.session_data.LSDateTime = this.GetTimeByZone(
          this.LSDateTime,
          this.EventData.TimeZone
        );
      }
      this.session_data.ResourceFiles = this.ResourceFiles;
      this.ResourceFiles = [];
      //console.log(this.session_data)
      this.$store
        .dispatch("sessionManagement/updateSession", {
          id: ID,
          data: this.session_data,
          scheduleInUTC: scheduleInUTC,
          SelectedGroups: this.SelectedGroups,
          SelectedAttendees: this.SelectedAttendees,
          NotificationHtml: this.welcomeMailText,
          NotificationSubject: this.welcomeMailSubject,
          Batch: this.Batch
        })
        .then((res) => {
          this.$vs.loading.close();
          if (res.status == 200) {

            if(res.notificationScheduleError){
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                fixed: true,
                icon: "close",
                title: res.notificationScheduleError.errorField,
                text: res.notificationScheduleError.errorMessage,
              });
            }


            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Session",
              text: "Session updated successfully.",
            });
            if(form_continue)
              this.$refs.forwizard.nextTab();          
            else
              this.$router.push("/event/sessions/");
          }

          if (res.status == 500) {
            this.$vs.notify({
              color: "warning",
              position: "top-right",
              fixed: true,
              icon: "close",
              title: "Session not updated!",
              text: res.ScheduleTimeresponse.response,
            });
          }
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },

    successUpload(event) {
      //console.log(event)
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Lorem ipsum dolor sit amet, consectetur",
      });
    },
    addTrack() {
      /* eslint-disable */
      if (!this.TrackName) return;

      this.$store
        .dispatch("trackManagement/addTrackFromPopup", {
          TrackName: this.TrackName,
          ColorCode: this.ColorCode,
        })
        .then((res) => {
          alert(res.message);
          if (res.status == 200) {
            this.TrackName = "";
            this.ColorCode = "";
            this.popupActive = false;
            this.getTracks();
          }
        })
        .catch((err) => {
          //console.error(err)
        });
    },
    addSpeaker() {
      this.$validator.validateAll('form-speaker').then((result) => {
        if(result){
          this.$vs.loading();
          this.$store
            .dispatch("speakerManagement/addSpeaker", {
              data: this.SpeakerObj,
            })
            .then((res) => {
              this.$vs.loading.close();
              if (res.status == 200) {
                vm.popupSpeakerAdd = false;
                vm.getSpeakers();
                this.$vs.notify({
                color: "success",
                  position: "top-center",
                  title: "Speaker",
                  text: "Speaker created successfully.",
                });
              }
              else
              {
                this.$vs.notify({
                  color: "warning",
                  position: "top-center",
                  title: "Speaker",
                  text: res.message,
                });
              }
            })
        }  
      })    
    },
    editUrl() {
      this.popupActive2 = false;
      this.session_data.IsManualUrl = true;
      if (this.session_data.TypeID == 1)
        this.session_data.ODVideoURL = this.editUrlText;
      else if (this.session_data.TypeID == 2)
        this.session_data.LSVideoURL = this.editUrlText;
      this.editUrlText = null;
    },
    fetch_photowallAlbum() {
      this.$store
        .dispatch("photowallManagement/fetchPhotowallAlbum") //fetchphotowallAlbum
        .then((res) => {
          this.PhotoWallAlbumList = res;
        });
    },
    checkScheduling() {
      let sessionId = this.$route.params.sessionId;
      this.$vs.loading();
      let requestData = {
        instanceId: "OA_UAT",
        clientId: Session_Client_Id,
        eventId: Session_Event_Id,
        sessionId: sessionId,
      };
      this.$store
        .dispatch("sessionManagement/getLiveSessionInfo", {
          requestData: requestData,
        })
        .then((res) => {
          console.log(res);
          this.$vs.loading.close();
          this.popupActive3 = true;
          this.schedulingMessage = "";
          if (res && res.data.status == 0) {
            if (res.data.data.dateUploaded)
              this.schedulingMessage +=
                "<p>Time of Upload: " +
                moment
                  .tz(
                    new Date(res.data.data.dateUploaded).toString(),
                    Session_Event_TZ
                  )
                  .format("MMMM DD, YYYY HH:mm") +
                "</p>";
            if (res.data.data.videoDuration)
              this.schedulingMessage +=
                "<p>Video length: " + res.data.data.videoDuration + "</p>";
            if (res.data.data.transcodePercent)
              this.schedulingMessage +=
                "<p>Video Transcoded: " +
                res.data.data.transcodePercent +
                "%</p>";
            if (res.data.data.schedule)
              this.schedulingMessage +=
                "<p>Scheduled At: " +
                moment
                  .tz(
                    new Date(res.data.data.schedule.createdAt).toString(),
                    Session_Event_TZ
                  )
                  .format("MMMM DD, YYYY HH:mm") +
                "</p>";
          }
        });
    },
    getSessionBatches(){
      if(['EDU', 'UAT'].includes(this.Environment)){
        this.$store.dispatch("sessionManagement/fetchSessionBatches").then((res) => {
          this.SessionBatchList = res;
        })
      }
    }
  },
  mounted() {
    let id = this.$route.params.sessionId;
    let cn = ls.getSessionEventCollectionName();
    let sessionRef = con.eventDB
      .collection(cn)
      .doc("SessionList")
      .collection("Sessions")
      .doc(id);
    sessionRef.onSnapshot(function (doc) {
      if (doc.data().SessionTypeDetails.TypeID == 1)
        vm.session_data.ODVideoURL = doc.data().SessionTypeDetails.VideoURL;
      else if (doc.data().SessionTypeDetails.TypeID == 2)
        vm.session_data.LSVideoURL = doc.data().SessionTypeDetails.LiveStreamURL;
    });
  },
  created() {
    vm = this;
    //debugger;
    // Register Module SessionManagement Module
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    this.fetchClientPlanDetails();
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }
    this.fetch_session_data(this.$route.params.sessionId);
    this.getSessionBatches();
    this.getMailTpl(false);
    if (this.$route.params.activeWizard) {
      this.activeWizard = this.$route.params.activeWizard;
    }
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule('attendeeManagement', moduleAttendeeManagement)
      moduleAttendeeManagement.isRegistered = true
    } 
    this.getAttendees();
    if (!moduleSpeakerManagement.isRegistered) {
      this.$store.registerModule("speakerManagement", moduleSpeakerManagement);
      moduleSpeakerManagement.isRegistered = true;
    }
    this.getSpeakers();
    if (!moduleTrackManagement.isRegistered) {
      this.$store.registerModule("trackManagement", moduleTrackManagement);
      moduleTrackManagement.isRegistered = true;
    }
    this.getTracks();
    if (!moduleRoundTableManagement.isRegistered) {
      this.$store.registerModule(
        "roundtableManagement",
        moduleRoundTableManagement
      );
      moduleRoundTableManagement.isRegistered = true;
    }
    this.getRoundTables();
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    this.fetch_event_data();
    if (!modulePhotoWall.isRegistered) {
      this.$store.registerModule("photowallManagement", modulePhotoWall);
      modulePhotoWall.isRegistered = true;
    }
    this.fetch_photowallAlbum();
    this.$store.dispatch("agendaManagement/fetchGroups").then(function(res) {
        vm.GroupList = res.map(row=>{
          return {
            GroupId: row.GroupId,
            GroupName: row.GroupName
          }
        });
    });
  },
};
</script>